import { RootState } from "@/app/stores/store";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../api/hooks/useAuth";

export const AuthLayout: React.FC = () => {
    const { isAuthenticated } = useSelector((state: RootState) => state.auth);
    const { isLoading, error } = useAuth();

    if (isLoading) {
        return (
            <div className="h-screen w-screen flex items-center justify-center bg-[#0078D7]">
                <div className="flex flex-col items-center">
                    <div className="w-16 h-16 border-4 border-white border-solid rounded-full border-t-transparent animate-spin mb-4"></div>
                    <div className="text-white text-xl">Logging in...</div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
                <div className="text-center text-red-500">{error}</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};
